import { ShiftInterface } from '../../../interfaces/shift.interface';

export class PickShift {
    public static readonly type = '[JobsPlacements] Pick a shift';

    constructor(public shift: ShiftInterface | null) {}
}
